import stylesTheme from "../stylesTheme";

export const MuiTable = {
  MuiTable: {
    root: {
      borderRadius: "4px",
      backgroundColor: "white",
    },
  },
  MuiTableRow: {
    root: {
      "&:last-child td": {
        borderBottom: 0,
      },
    },
  },
  MuiTableCell: {
    root: {
      padding: "12px 16px",
    },
    head: {
      fontWeight: 600,
      color: stylesTheme.palette.text.primary,
      fontSize: stylesTheme.typography.pxToRem(18),
      padding: "18px 16px",
    },
    body: {
      color: stylesTheme.palette.text.primary,
      fontSize: stylesTheme.typography.pxToRem(14),
    },
  },
  MuiTablePagination: {
    root: {
      overflow: "visible",
      marginLeft: stylesTheme.spacing(2),
    },
    caption: {
      fontWeight: stylesTheme.typography.fontWeightRegular,
      fontSize: stylesTheme.typography.pxToRem(14),
      color: stylesTheme.palette.text.primary,
    },
    select: {
      fontWeight: stylesTheme.typography.fontWeightRegular,
      fontSize: stylesTheme.typography.pxToRem(14),
    },
    toolbar: {
      padding: `${stylesTheme.typography.pxToRem(8)} 0`,
    },
  },
};
